// Reusable cancellation / no-show / extension policy panel for the booking flow.
import React from 'react';
import { ShieldAlert, Clock4, Info } from 'lucide-react';
import { CANCELLATION_POLICY, NO_SHOW_POLICY, EXTENSION_POLICY } from '../constants/policies';

const toneClass = {
  positive: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  neutral: 'bg-blue-50 text-blue-700 border-blue-200',
  warning: 'bg-amber-50 text-amber-800 border-amber-200',
  info: 'bg-purple-50 text-purple-700 border-purple-200',
};

export default function PolicyPanel({ compact = false }) {
  return (
    <div className="card p-5" data-testid="policy-panel">
      <div className="flex items-center gap-2 mb-3">
        <ShieldAlert size={20} className="text-primary" />
        <h3 className="text-lg font-heading font-semibold text-[#2D3748]">Cancellation & Refund Policy</h3>
      </div>

      <ul className="space-y-2 mb-4" data-testid="policy-list">
        {CANCELLATION_POLICY.map((row, i) => (
          <li
            key={i}
            className={`flex items-start gap-3 p-3 rounded-xl border text-sm ${toneClass[row.tone] || ''}`}
            data-testid={`policy-row-${i}`}
          >
            <span className="font-medium min-w-[12rem] md:min-w-[14rem]">{row.window}</span>
            <span>{row.outcome}</span>
          </li>
        ))}
      </ul>

      {!compact && (
        <div className="grid md:grid-cols-2 gap-3 mt-2">
          <div className="flex items-start gap-2 p-3 rounded-xl bg-[#FAF9F6] text-xs text-[#4A5568]">
            <Clock4 size={16} className="text-[#718096] mt-0.5 shrink-0" />
            <span data-testid="policy-no-show"><strong>No-show:</strong> {NO_SHOW_POLICY}</span>
          </div>
          <div className="flex items-start gap-2 p-3 rounded-xl bg-[#FAF9F6] text-xs text-[#4A5568]">
            <Info size={16} className="text-[#718096] mt-0.5 shrink-0" />
            <span data-testid="policy-extension"><strong>Session extension:</strong> {EXTENSION_POLICY}</span>
          </div>
        </div>
      )}
    </div>
  );
}
